import { render } from "./FoerderdokumenteDetails.pug?vue&type=template&id=2b194c5e&lang=pug"
import script from "./FoerderdokumenteDetails.js?vue&type=script&lang=js"
export * from "./FoerderdokumenteDetails.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__